import annika from '../images/brand-logos/annika.svg';
import ibkul from '../images/brand-logos/ibkul.png';
import sporteLeisure from '../images/brand-logos/sporte-leisure-logo.png';
import corsicanGolf from '../images/brand-logos/corsican-golf.svg';
import dailySports from '../images/brand-logos/daily-sports.svg';
import gregNorman from '../images/brand-logos/greg-norman.svg';
import jamieSadock from '../images/brand-logos/jamie-sadock.svg';
import nivo from '../images/brand-logos/nivo.svg';
import redBellyActive from '../images/brand-logos/red-belly-active.svg';
import travisMatthews from '../images/brand-logos/travis-matthews.svg';

export const brands = [
  // {
  //   label: 'Annika',
  //   slug: '/ladies/collections/annika/',
  //   icon: annika,
  //   theme: 'ladies',
  // },
  {
    label: 'IBKUL',
    slug: '/ladies/collections/ibkul/',
    icon: ibkul,
    theme: 'ladies',
  },
  {
    label: 'Travis Matthews',
    slug: '/mens/collections/travis-mathew/',
    icon: travisMatthews,
    theme: 'mens',
  },
  {
    label: 'Corsican Golf',
    slug: '/ladies/collections/corsican-golf/',
    icon: corsicanGolf,
    theme: 'ladies',
  },
  {
    label: 'Jamie Sadock',
    slug: '/ladies/collections/jamie-sadock-brand/',
    icon: jamieSadock,
    theme: 'ladies',
  },
  {
    label: 'Nivo',
    slug: '/ladies/collections/nivo/',
    icon: nivo,
    theme: 'ladies',
  },
  {
    label: 'Greg Norman',
    slug: '/mens/collections/greg-norman/',
    icon: gregNorman,
    theme: 'mens',
  },
  {
    label: 'Daily Sports',
    slug: '/ladies/collections/daily-sports/',
    icon: dailySports,
    theme: 'ladies',
  },
  {
    label: 'Sporte Leisure',
    slug: '/ladies/collections/sporte-leisure/',
    icon: sporteLeisure,
    theme: 'ladies',
  },
];
